import * as React from 'react';

type Props = {
  defaultValue: string,
  name: string,
  type: string,
  checkboxLabel: string,
  isRequired?: boolean,
  min?: string|null,
  max?: string|null,
  step?: string|null,
};

const LimitExitField: React.FC<Props> = ({
  defaultValue,
  name,
  type,
  checkboxLabel,
  isRequired = false,
  min = null,
  max = null,
  step = null,
}) => {
  const [value, setValue] = React.useState<string>(defaultValue);
  const [isChecked, setIsChecked] = React.useState<boolean>(!!Number(defaultValue));

  return <>
    <div className="form-check">
      <label className="form-check-label">
        <input className="form-check-input" type="checkbox"
          checked={isChecked}
          onChange={_e => setIsChecked(!isChecked)}
        />
        {checkboxLabel}
      </label>
    </div>
    {isChecked && <div className="input-group">
      <input
        type={type}
        className="form-control form-control-lg"
        value={value}
        onChange={e => setValue(e.target.value)}
        required={isRequired}
        min={min ?? undefined}
        max={max ?? undefined}
        step={step ?? undefined}
      />
      <span className="input-group-text">%</span>
    </div>}
    <input type="hidden" name={name} value={isChecked ? value : ''} />
  </>;
};

export default LimitExitField;
